import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-cart-manage-sampling-menu',
    templateUrl: './cart-manage-sampling-menu.component.html',
    styleUrls: ['./cart-manage-sampling-menu.component.scss']
})
export class CartManageSamplingMenuComponent {
    @Output() onEdit = new EventEmitter();
    @Output() onDuplicate = new EventEmitter();
    @Output() onDelete = new EventEmitter();
    @Input() isProductGroup = false;

    constructor() { }

    edit($event) {
        this.onEdit.emit($event);
    }

    duplicate($event) {
        this.onDuplicate.emit($event);
    }

    delete($event) {
        this.onDelete.emit($event);
    }
}
